import { render, staticRenderFns } from "./submit-task.vue?vue&type=template&id=0b1cae9c&"
import script from "./submit-task.vue?vue&type=script&lang=js&"
export * from "./submit-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports